<template>
  <img
    class="object-contain w-full h-10"
    alt="Payje logo"
    src="@/assets/image/logo-payje.svg"
  />
</template>
